export function getUmbracoPDFUrl(url?: string) {
  const GRAPHQL_URL = process.env.GRAPHQL_URL?.replace("/graphql", "")
  // Temporary until figure out how to pass Server Env to client component. Possible Solution is prefix
  // GRAPHQL_URL with NEXT_PUBLIC_GRAPHQL_URL
  if (!url) {
    return ""
  }
  return GRAPHQL_URL + url
}
